import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import AboutBannerImg1 from '../assets/images/find-your-own-agent.png';
import ArrowIcon from '../assets/images/button-arrow.svg';
import {ASSETS_URL} from "../api/constants";
import { Link } from "react-router-dom"
const FindYourOwnAgent = ({ data, loading }) => {
  return (
    <section className="about-banner-section">
      <Row>
        <Col lg={6} md={12}>
          <div className="about-image">
            <img
              src={data?.image ? `${ASSETS_URL}/${data.image}` : AboutBannerImg1}
              alt="Modern House"
              className="house-img"
            />
          </div>
        </Col>
        <Col lg={6} md={12} className='about-content-box align-self-center'>
          <div className="about-content">
            <h1
              className="about-title d-flex align-items-center"
              dangerouslySetInnerHTML={{ __html: data?.title || "" }}
            />
            <div dangerouslySetInnerHTML={{ __html: data?.description || "" }} />
            <Link to={data?.btn_link || '/find-an-agent'} className="custom-bttn style-3 ani-1 right">
              {data?.btn_name || "Find an Agent"} <img src={ArrowIcon} alt="Arrow Icon" />
            </Link>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default FindYourOwnAgent;